import {
  AfterViewInit,
  Component,
  OnInit,
  QueryList,
  ViewChildren,
  ChangeDetectorRef,
  ViewEncapsulation,
  HostListener,
  ElementRef,
  ViewChild,
  Input,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CartService } from 'src/app/services/cart/cart.service';
import { CategoryService } from 'src/app/services/category/category.service';
import { MatMenu } from '@angular/material/menu';
import { LoginComponent } from 'src/app/components/modals/login/login.component';
import { RegisterComponent } from 'src/app/components/modals/register/register.component';
import {
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth/auth.service';
import { OptimizedI18nService } from 'src/app/services/optimized-i18n.service';
import {
  faX,
  faTrash,
  faPlus,
  faCartShopping,
  faMinus,
  faAngleDown,
  faSearch,
  faBell,
} from '@fortawesome/free-solid-svg-icons';
import { faUser, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { filter, takeUntil } from 'rxjs/operators';
import { MobileService } from 'src/app/services/mobile.service';
import { Subject, Subscription } from 'rxjs';
import { ProductAddedToCartComponent } from '../modals/product-added-to-cart/product-added-to-cart.component';

@Component({
  selector: 'app-header-pages',
  templateUrl: './header-pages.component.html',
  styleUrls: ['./header-pages.component.scss'],
})
export class HeaderPagesComponent implements OnInit, AfterViewInit {
  @Input() showSearchBar: boolean = true;
  faCartShopping = faCartShopping;
  currentLanguage: string = 'es';
  faX = faX;
  faTrash = faTrash;
  faMinus = faMinus;
  faPlus = faPlus;
  faSearch = faSearch;
  faAngleDown = faAngleDown;
  faUser = faUserCircle;
  faBell = faBell;

  modalCarga?: NgbModalRef;
  cartItems: any[] = [];
  menuOpen: boolean = false;
  loading: boolean = false;
  error: string = '';
  categoriesOpen: boolean = false;
  totalItems: number = 0;
  totalAmount: number = 0;
  categories: any[] = [];
  isLoading: boolean = false;
  subMenus: { [key: string]: MatMenu } = {};
  ngbModalOptions: NgbModalOptions = {
    backdropClass: 'modal-backdrop-blur',
    backdrop: 'static',
    keyboard: false,
    centered: true,
  };
  @ViewChildren('menuRef') menuRefs!: QueryList<MatMenu>;
  @ViewChild('notificationsContainer') notificationsRef!: ElementRef;

  isLoggedIn: boolean = false;
  userName: string = '';
  altoReindimiento = [
    { name: 'Entrenamiento', _id: '67d48a874a3c980057c3cb0f' },
    { name: 'Competencia', _id: '67d48a874a3c980057c3cb9e' },
    { name: 'Recuperación', _id: '67d48a874a3c980057c3cb9f' },
  ];
  listServicios = [
    {
      name: 'Med-Veterinarios/ Especialidades',
      _id: '67da3495df85cc4e48522025',
    },
    { name: 'Asociaciones', _id: '67da3495df85cc4e48522021' },
    { name: 'Clases Disciplinas Ecuestres', _id: '67da3495df85cc4e48522020' },
    { name: 'Manejo Caballos', _id: '67da3495df85cc4e48522022' },
    { name: 'Instituciones Académicas', _id: '67da3495df85cc4e48522024' },
    { name: 'Otros', _id: '67da3495df85cc4e48522023' },
  ];
  isProfileDropDownMenuVisible: boolean = false;

  notificationsOpen = false;
  notifications: any[] = [];
  unreadNotificationsCount = 0;

  private mobileSubscription: Subscription;
  isMobile: boolean = false;


  private destroy$ = new Subject<void>();
  private cartSubscription?: Subscription;

  constructor(
    private categoryService: CategoryService,
    public cartService: CartService,
    private router: Router,
    private modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private elementRef: ElementRef,
    private mobileService: MobileService,
    private i18nService: OptimizedI18nService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        // if (!event.url.includes('/user')) {
        //   this.loadCategories();
        // }
      });
  }

  ngOnInit(): void {
    if (this.cartService.cartOpen()) {
      this.cartService.toggleCart();
    }
    
    // Inicializar idioma actual
    this.currentLanguage = localStorage.getItem('selectedLanguage') || 'es';
    
    this.mobileSubscription = this.mobileService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
      if (this.isMobile && this.isProfileDropDownMenuVisible) {
        this.isProfileDropDownMenuVisible = false;
      }
    });
    this.cartService.loadCartFromStorage();

    // Inicializar idioma
    const savedLang = localStorage.getItem('selectedLanguage') || 'es';
    setTimeout(() => {
      this.changeLanguage(savedLang);
    }, 100);
    this.cartSubscription = this.cartService.totalItems$.subscribe((count) => {
      this.totalItems = count;
    });

    // this.authService.loginSuccess$
    // .pipe(takeUntil(this.destroy$))
    // .subscribe(() => {
    //     this.checkLoginStatus();
    // });

    this.checkLoginStatus();
  }

  toggleNotifications() {
    event.stopPropagation();
    this.notificationsOpen = !this.notificationsOpen;
    if (this.notificationsOpen) {
      this.isProfileDropDownMenuVisible = false;
    }
  }

  closeNotifications() {
    this.notificationsOpen = false;
  }

  loadNotifications() {
    this.authService.getNotifications().subscribe({
      next: (response) => {
        //Mantenemos el valor 'read' que viene del backend o false si no existe
        this.notifications = response.data;

        //Contamos solo las que tienen read: false
        this.unreadNotificationsCount = this.notifications.filter(n => n.viewed === false).length;
      },
      error: (error) => {
        console.error('Error al cargar notificaciones:', error);
        this.notifications = [];
        this.unreadNotificationsCount = 0;
      }
    });
  }

  markNotificationsAsRead() {
    this.authService.markNotificationAsRead().subscribe({
      next: () => {
        // Marcamos como leídas localmente
        this.notifications = this.notifications.map(notification => ({
          ...notification,
          viewed: false
        }));
        this.unreadNotificationsCount = 0;
      },
      error: (error) => {
        console.error('Error al marcar notificaciones como leídas:', error);
        // Podemos marcarlas como leídas localmente aunque falle en el backend
        this.notifications = this.notifications.map(notification => ({
          ...notification,
          viewed: false
        }));
        this.unreadNotificationsCount = 0;
      }
    });
  }

  private loadCategories(): void {
    if (this.categories.length === 0) {
      this.getCategories();
    }
  }

  ngAfterViewInit(): void {
    this.menuRefs.changes.subscribe(() => {
      this.assignMenus();
    });
  }

  checkLoginStatus(): void {
    const userData = this.authService.getUserData();
    if (userData) {
      this.isLoggedIn = true;
      this.userName = userData.data_user.name;
      this.loadNotifications();
    } else {
      this.isLoggedIn = false;
      this.userName = '';
    }
    // Force change detection to update the view
    this.cdr.detectChanges();
  }
  goHome() {
    this.router.navigate(['/home']);
  }
  goProfile() {
    this.router.navigate(['/user/profile']);
  }
  goModule(): void {
    this.router.navigate(['/user']);
  }
  goServices(id: any) {
    this.router.navigate(['/home/list-services/'], {
      queryParams: { serviceId: id },
    });
  }
  assignMenus(): void {
    this.subMenus = {};
    const menuArray = this.menuRefs.toArray();
    this.categories.forEach((category, index) => {
      this.subMenus[category._id] = menuArray[index];
    });
  }

  getCategories(): void {
    // this.isLoading = true;
    this.categoryService.getAllCategory().subscribe({
      next: (data: any) => {
        this.categories = data;
        this.isLoading = false;
        this.cdr.detectChanges();
        this.assignMenus();
      },
      error: (err) => {
        console.error('Error al cargar las categorías:', err);
        this.error = 'Error al cargar las categorías';
        this.isLoading = false;
      },
    });
  }

  toggleCart(): void {
    this.cartService.toggleCart();
  }

  toggleSubcategories(category: any): void {
    category.subcategoriesOpen = !category.subcategoriesOpen;
  }

  checkout(): void {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/home/checkout']);
    } else {
      this.modalCarga = this.modalService.open(
        LoginComponent,
        this.ngbModalOptions
      );
      this.modalCarga.result.then(
        (data: any) => {
          if (data === 'login') {
            this.router.navigate(['/home/checkout']);
          } else {
          }
          this.checkLoginStatus();
        },
        () => {
          this.checkLoginStatus();
        }
      );
    }
  }

  goProductCat(cat: any, subCar: any): void {
    this.router.navigate([`/home/detail-category/${cat}`], {
      queryParams: { subcat: subCar },
    });
  }

  login() {
    this.modalCarga = this.modalService.open(
      LoginComponent,
      this.ngbModalOptions
    );
    this.modalCarga.result.then(
      () => {
        this.checkLoginStatus();
      },
      () => {
        this.checkLoginStatus();
      }
    );
  }

  register() {
    this.modalCarga = this.modalService.open(
      RegisterComponent,
      this.ngbModalOptions
    );
    this.modalCarga.result.then(
      () => {
        this.checkLoginStatus();
      },
      () => {
        this.checkLoginStatus();
      }
    );
  }


  toggleProfileDropDownMenu(event: Event) {
    event.stopPropagation();
    this.isProfileDropDownMenuVisible = !this.isProfileDropDownMenuVisible;
    if (this.isProfileDropDownMenuVisible && this.notificationsOpen) {
      this.notificationsOpen = false;
    }
  }

  logout() {
    // Removed window.location.reload() to prevent page refresh
    // The header will update automatically through checkLoginStatus()
    this.modalCarga = this.modalService.open(
        ProductAddedToCartComponent,
        this.ngbModalOptions
    );
    this.modalCarga.componentInstance.title = "¿Estás seguro que deseas cerrar sesión?";
    this.modalCarga.componentInstance.textFirstButton = 'Cerrar sesión';
    this.modalCarga.componentInstance.textSecondButton = 'Cancelar';
    this.modalCarga.componentInstance.firstButtonAction = () => {
      this.authService.logout();
      this.cartService.clearCart();
      this.modalCarga.close('close');
      setTimeout(() => {
        window.location.href = '/home';
      }, 200);
    };
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    this.handleProfileDropdownClick(event);
    this.handleNotificationsClick(event);
  }

  private handleProfileDropdownClick(event: Event) {
    const clickedElement = event.target as HTMLElement;
    const dropdownButton = this.elementRef.nativeElement.querySelector('.user-icon');
    const dropdownMenu = this.elementRef.nativeElement.querySelector('.profile-dropdown-menu');

    if (dropdownButton &&
      !dropdownButton.contains(clickedElement) &&
      (!dropdownMenu || !dropdownMenu.contains(clickedElement)) &&
      this.isProfileDropDownMenuVisible) {
      this.isProfileDropDownMenuVisible = false;
    }
  }

  private handleNotificationsClick(event: Event) {
    const clickedElement = event.target as HTMLElement;

    if (this.notificationsOpen) {
      if (this.notificationsRef.nativeElement && !this.notificationsRef.nativeElement.contains(clickedElement)) {
        this.closeNotifications();
      }
    }
  }

  ngOnDestroy() {
    if (this.mobileSubscription) {
      this.mobileSubscription.unsubscribe();
    }
    if (this.cartSubscription) {
      this.cartSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeLanguage(languageCode: string): void {
    
    // Actualizar idioma actual
    this.currentLanguage = languageCode;
    
    // Guardar en localStorage
    localStorage.setItem('selectedLanguage', languageCode);
    
    // Actualizar el atributo lang del HTML
    document.documentElement.lang = languageCode;
    
    // Usar el servicio de traducción
    this.i18nService.setLanguage(languageCode);
    
    // Forzar detección de cambios
    this.cdr.detectChanges();
    
    // NO recargar la página - cambio instantáneo
  }
}
